import ClassicEditor from "@ckeditor/ckeditor5-editor-classic/src/classiceditor";
import Essentials from "@ckeditor/ckeditor5-essentials/src/essentials";
import Blockquote from "@ckeditor/ckeditor5-block-quote/src/blockquote";
import Heading from "@ckeditor/ckeditor5-heading/src/heading";
import Paragraph from "@ckeditor/ckeditor5-paragraph/src/paragraph";
import Bold from "@ckeditor/ckeditor5-basic-styles/src/bold";
import Italic from "@ckeditor/ckeditor5-basic-styles/src/italic";
import Underline from "@ckeditor/ckeditor5-basic-styles/src/underline";
import RemoveFormat from "@ckeditor/ckeditor5-remove-format/src/removeformat";
import Font from "@ckeditor/ckeditor5-font/src/font";
import List from "@ckeditor/ckeditor5-list/src/list";
import Link from "@ckeditor/ckeditor5-link/src/link";
import Alignment from "@ckeditor/ckeditor5-alignment/src/alignment";
import PasteFromOffice from "@ckeditor/ckeditor5-paste-from-office/src/pastefromoffice";
import CKFinder from "@ckeditor/ckeditor5-ckfinder/src/ckfinder";
import MediaEmbed from "@ckeditor/ckeditor5-media-embed/src/mediaembed";
import Image from "@ckeditor/ckeditor5-image/src/image";
import ImageToolbar from "@ckeditor/ckeditor5-image/src/imagetoolbar";
import ImageCaption from "@ckeditor/ckeditor5-image/src/imagecaption";
import ImageStyle from "@ckeditor/ckeditor5-image/src/imagestyle";
import ImageResize from "@ckeditor/ckeditor5-image/src/imageresize";

const appUrl = document.head
    .querySelector('meta[name="app-url"]')
    .getAttribute("content");
let availableFontSizes = [];
const defaultFontSize = 14;
window.ckeditors = {};

for (let i = 8; i <= 24; i++) {
    if (i % 2 != 0) continue;
    if (i == defaultFontSize) {
        availableFontSizes.push("default");
        continue;
    }
    availableFontSizes.push(i);
}

$(() => {
    $(".editor:not(.vue-editor)").each(function () {
        ClassicEditor.create(this, {
            fontSize: {
                options: availableFontSizes,
            },
            plugins: [
                Essentials,
                Blockquote,
                Heading,
                Paragraph,
                Bold,
                Italic,
                Underline,
                RemoveFormat,
                Font,
                List,
                Alignment,
                PasteFromOffice,
                CKFinder,
                MediaEmbed,
                Image,
                ImageToolbar,
                ImageCaption,
                ImageStyle,
                ImageResize,
                Link,
            ],
            toolbar: [
                "heading",
                "blockQuote",
                "|",
                "bold",
                "italic",
                "underline",
                "removeFormat",
                "|",
                "fontColor",
                "fontSize",
                "fontFamily",
                "|",
                "bulletedList",
                "numberedList",
                "alignment",
                "|",
                "link",
                "|",
                "ckfinder",
                "mediaEmbed",
            ],
            fontFamily: {
                options: [
                    "default",
                    // 'American Typewriter, serif',
                    // 'Andale Mono, monospace',
                    "Arial, Helvetica, sans-serif",
                    "Arial Black, Arial, Helvetica, sans-serif",
                    "Bradley Hand ITC, Comic Sans MS, cursive",
                    "Brush Script MT, cursive",
                    "Comic Sans MS, cursive",
                    "Copperplate Gothic, sans-serif",
                    "Courier New, Courier, monospace",
                    // 'Didot, serif',
                    // 'Georgia, serif',
                    // 'Gill Sans, sans-serif',
                    "Helvetica, Arial, sans-serif",
                    "Impact, fantasy",
                    "Lucida Sans Unicode, Lucida Grande, sans-serif",
                    // 'Luminari, fantasy',
                    // 'Optima, sans-serif',
                    // 'Rockwell, serif',
                    // 'Tahoma, Geneva, sans-serif',
                    "Times New Roman, Times, serif",
                    "Trebuchet MS, Helvetica, sans-serif",
                    "Verdana, Geneva, sans-serif",
                ],
            },
            image: {
                // You need to configure the image toolbar, too, so it uses the new style buttons.
                toolbar: [
                    "imageStyle:alignLeft",
                    "imageStyle:full",
                    "imageStyle:alignRight",
                ],

                styles: [
                    // This option is equal to a situation where no style is applied.
                    "full",

                    // This represents an image aligned to the left.
                    "alignLeft",

                    // This represents an image aligned to the right.
                    "alignRight",
                ],
            },
        })
            .then((editor) => {
                window.ckeditors[$(this).attr("id")] = editor;
                const uploadTargetHash = "l1_Lw";
                const ckf = editor.commands.get("ckfinder"),
                    fileRepo = editor.plugins.get("FileRepository"),
                    // Insert images to editor window
                    insertImages = (urls) => {
                        editor.execute("imageInsert", { source: urls });
                    },
                    // To get elFinder instance
                    getfm = (open) => {
                        return new Promise((resolve, reject) => {
                            // Execute when the elFinder instance is created
                            const done = () => {
                                if (open) {
                                    // request to open folder specify
                                    if (!Object.keys(_fm.files()).length) {
                                        // when initial request
                                        _fm.one("open", () => {
                                            _fm.file(open)
                                                ? resolve(_fm)
                                                : reject(
                                                      _fm,
                                                      "errFolderNotFound"
                                                  );
                                        });
                                    } else {
                                        // elFinder has already been initialized
                                        new Promise((res, rej) => {
                                            if (_fm.file(open)) {
                                                res();
                                            } else {
                                                // To acquire target folder information
                                                _fm.request({
                                                    cmd: "parents",
                                                    target: open,
                                                })
                                                    .done((e) => {
                                                        _fm.file(open)
                                                            ? res()
                                                            : rej();
                                                    })
                                                    .fail(() => {
                                                        rej();
                                                    });
                                            }
                                        })
                                            .then(() => {
                                                // Open folder after folder information is acquired
                                                _fm.exec("open", open)
                                                    .done(() => {
                                                        resolve(_fm);
                                                    })
                                                    .fail((err) => {
                                                        reject(
                                                            _fm,
                                                            err
                                                                ? err
                                                                : "errFolderNotFound"
                                                        );
                                                    });
                                            })
                                            .catch((err) => {
                                                reject(
                                                    _fm,
                                                    err
                                                        ? err
                                                        : "errFolderNotFound"
                                                );
                                            });
                                    }
                                } else {
                                    // show elFinder manager only
                                    resolve(_fm);
                                }
                            };

                            // Check elFinder instance
                            if (_fm) {
                                // elFinder instance has already been created
                                done();
                            } else {
                                // To create elFinder instance
                                _fm = $("<div/>")
                                    .dialogelfinder({
                                        // dialog title
                                        title: "File Manager",
                                        // connector URL
                                        url: `${appUrl}/elfinder/connector`,
                                        // start folder setting
                                        startPathHash: open ? open : void 0,
                                        // Set to do not use browser history to un-use location.hash
                                        useBrowserHistory: false,
                                        // Disable auto open
                                        autoOpen: false,
                                        // elFinder dialog width
                                        width: "80%",
                                        uiOptions: {
                                            // toolbar configuration
                                            toolbar: [
                                                ["back", "forward", "up"],
                                                ["mkdir", "upload", "download"],
                                                ["help"],
                                            ],
                                        },
                                        // set getfile command options
                                        commandsOptions: {
                                            getfile: {
                                                oncomplete: "close",
                                                multiple: true,
                                            },
                                        },
                                        // Insert in CKEditor when choosing files
                                        getFileCallback: (files, fm) => {
                                            let imgs = [];
                                            fm.getUI("cwd").trigger(
                                                "unselectall"
                                            );
                                            $.each(files, function (i, f) {
                                                if (
                                                    f &&
                                                    f.mime.match(/^image\//i)
                                                ) {
                                                    imgs.push(
                                                        fm.convAbsUrl(f.url)
                                                    );
                                                } else {
                                                    editor.execute(
                                                        "link",
                                                        fm.convAbsUrl(f.url)
                                                    );
                                                }
                                            });
                                            if (imgs.length) {
                                                insertImages(imgs);
                                            }
                                        },
                                    })
                                    .elfinder("instance");
                                done();
                            }
                        });
                    };

                // elFinder instance
                let _fm;

                if (ckf) {
                    // Take over ckfinder execute()
                    ckf.execute = () => {
                        getfm().then((fm) => {
                            fm.getUI().dialogelfinder("open");
                            $(".dialogelfinder").css("top", "20%");
                        });
                    };
                }

                // Make uploader
                const uploder = function (loader) {
                    this.upload = function () {
                        return new Promise(function (resolve, reject) {
                            getfm(uploadTargetHash)
                                .then((fm) => {
                                    let fmNode = fm.getUI();
                                    fmNode.dialogelfinder("open");
                                    fm.exec(
                                        "upload",
                                        {
                                            files: [loader.file],
                                            target: uploadTargetHash,
                                        },
                                        void 0,
                                        uploadTargetHash
                                    )
                                        .done((data) => {
                                            if (
                                                data.added &&
                                                data.added.length
                                            ) {
                                                fm.url(data.added[0].hash, {
                                                    async: true,
                                                })
                                                    .done(function (url) {
                                                        resolve({
                                                            default:
                                                                fm.convAbsUrl(
                                                                    url
                                                                ),
                                                        });
                                                        fmNode.dialogelfinder(
                                                            "close"
                                                        );
                                                    })
                                                    .fail(function () {
                                                        reject(
                                                            "errFileNotFound"
                                                        );
                                                    });
                                            } else {
                                                reject(
                                                    fm.i18n(
                                                        data.error
                                                            ? data.error
                                                            : "errUpload"
                                                    )
                                                );
                                                fmNode.dialogelfinder("close");
                                            }
                                        })
                                        .fail((err) => {
                                            const error = fm.parseError(err);
                                            reject(
                                                fm.i18n(
                                                    error
                                                        ? error === "userabort"
                                                            ? "errAbort"
                                                            : error
                                                        : "errUploadNoFiles"
                                                )
                                            );
                                        });
                                })
                                .catch((fm, err) => {
                                    const error = fm.parseError(err);
                                    reject(
                                        fm.i18n(
                                            error
                                                ? error === "userabort"
                                                    ? "errAbort"
                                                    : error
                                                : "errUploadNoFiles"
                                        )
                                    );
                                });
                        });
                    };
                    this.abort = function () {
                        _fm && _fm.getUI().trigger("uploadabort");
                    };
                };
                // Set up image uploader
                fileRepo.createUploadAdapter = (loader) => {
                    return new uploder(loader);
                };

                if ($(this).hasClass("read-only")) {
                    editor.isReadOnly = true;
                }
            })
            .catch((error) => {
                console.error(error);
            });
    });
});
